// axios.js
import axios from "axios";
import config from "./config";

const backend_url = config.backend_url;


const instance = axios.create({
  // Put your base URL here
  baseURL: `${backend_url}`,
  // Add withCredentials to ensure cookies are sent with requests
  withCredentials: true
});

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      // when you get a 401 error because of an expired/invalid token,
      // clear the stored user data and redirect to login page
      localStorage.removeItem('loggedIn');
      localStorage.removeItem('userType');
      localStorage.removeItem('userId');
      localStorage.removeItem('sellerData');

      // Redirect needs to be handled by components, not here
      // window.location = '/';
    }
    return Promise.reject(error);
  }
);

export default instance;